(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
    const variantInput = event.target.closest('input[data-variant-id]');
    if (!variantInput) return;

    const card = variantInput.closest('product-card');
    const purchaseVariant = card?.querySelector('.furvelis-card-purchase input[name="id"]');
    if (purchaseVariant && variantInput.dataset.variantId) {
      purchaseVariant.value = variantInput.dataset.variantId;
    }
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-quantity-change]');
    if (!button) return;

    const wrapper = button.closest('[data-card-quantity]');
    const input = wrapper?.querySelector('input[name="quantity"]');
    if (!input) return;

    const nextValue = Math.max(1, Number(input.value || 1) + Number(button.dataset.quantityChange));
    input.value = String(nextValue);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  } catch(e) { console.error(e); }
})();

})();
